import { GrowthBook } from '@growthbook/growthbook-react';
import { growthbookTrackingPlugin } from '@growthbook/growthbook/plugins';
import { amplitudeTracker } from './amplitude-tracker';
import { subscribe } from './event-logger';
import { GROWTHBOOK_EVENT_TYPES } from './event-types';

const growthBook = {
    instance: null,

    init(apiHost, clientKey) {
        const instance = new GrowthBook({
            apiHost,
            clientKey,
            enableDevMode: true,
            plugins: [growthbookTrackingPlugin({ enable: true })],
            trackingCallback: (experiment, result) => {
                console.log('Viewed Experiment', {
                    experimentId: experiment.key,
                    variationId: result.key
                });
            }
        });

        growthBook.instance = instance;

        return instance;
    },

    setUserAttributes() {
        growthBook.instance.setAttributes({
            id: amplitudeTracker.getDeviceId()
        });
    },

    loadFeatures() {
        growthBook.instance.loadFeatures({ autoRefresh: true, timeout: 2500 });
    },

    logEvent(eventName, properties) {
        growthBook.instance.logEvent(eventName, properties);
    },

    onSubscribe() {
        return subscribe((eventType, eventProperties = {}) => {
            if (GROWTHBOOK_EVENT_TYPES.hasOwnProperty(eventType)) {
                growthBook.logEvent(GROWTHBOOK_EVENT_TYPES[eventType], eventProperties);
            }
        });
    }
};

export {
    growthBook
};
